import * as React from 'react';
import { observer } from 'mobx-react';
import { TAX_INCLUDED } from '../../constants/DataTestIdAttributes';
import { translate } from '@estee/elc-service';

interface ITaxIncluded {
    translations: {
        taxIncluded: string;
    };
}

export const TaxIncluded = translate(['taxIncluded'])(
    observer(({ translations: { taxIncluded } }: ITaxIncluded) => {
        return (
            <div className="elc-product-tax-included-label-wrapper" data-test-id={TAX_INCLUDED}>
                {taxIncluded}
            </div>
        );
    })
);
